import { gql } from '@apollo/client'
import { PublicStarRentalLiteFragment } from '@src/graphql/fragment/orbitalTrack'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'

export default gql`
  query getPublicStarRental(
    $filterInput: GetOpenRentOrbitalTrackFilterInput!
    $sortBy: OpenRentOrbitalTrackSortBy!
    $pagingInput: PagingInput!
  ) {
    getOpenRentOrbitalTracks(
      filterInput: $filterInput
      sortBy: $sortBy
      pagingInput: $pagingInput
    ) {
      edges {
        node {
          ...PublicStarRentalLite
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${PublicStarRentalLiteFragment}
  ${PageInfoFragment}
`
